// xj add 20190814
import { errorModal } from './assets/js/xjcommon';

export default {
  data () {
    return {
      title: '首页'
    }
  },
  updated () {
    this.upactive()
  },
  mounted () {
    // 最初是放在Home.js中
    if (this.$store.state.isDev && !this.$cookies.get('tk')) {
      this.$cookies.set('customer_name', 'AutoCloud');
      this.$cookies.set('customer', 'autocloud');
      this.$cookies.set('openid', '');
      this.$cookies.set('imei', '');
      this.$cookies.set('tk', '');
    }

    // 每次加载的时候从cookie中获取最新token
    // 如果页面分享给没有关注该公众号的微信,则需要传参customer
    this.$store.state.customerName = this.$cookies.get('customer_name');
    this.$store.state.customer = this.$cookies.get('customer') || this.$route.query.customer;
    this.$store.state.nowImei = this.$cookies.get('imei');
    // 20191108 add 为了保证在其他页面使用时刷新重置为空的问题
    this.$store.state.wxInfo = this.$cookies.get('wxInfo');
    this.$store.state.nowIccid = this.$cookies.get('nowIccid');
    // $cookies end

    // console.error('APP_mounted');
    // 调试时使用
    /* eslint-disable */
    // if ( navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 ) {
    //   const sto = setInterval(function () {
    //     try{
    //       new VConsole();
    //       clearInterval(sto);
    //     }catch(e){}
    //   }, 1000);
    // }

    // 暴露出setCookie函数，让开发人员可以在chrome上面设置cookie
    const _this = this;
    window.setCookie = window.setCookie || function(obj){
      for( let i in obj ){
        if( !obj.hasOwnProperty(i) ){continue;}
        _this.$cookies.set(i, String(obj[i]));
      }
    };


  },
  methods: {
    onClickLeft () {
      // 点击回退的时候当做地址回退
      this.$router.go(-1)
    },
    upactive () {
      this.nowPath = this.$route.path;
      // console.log(this.nowPath);
      // vue提供的方法
      if (this.nowPath === '/') {
        // console.log('您好')
      }
    },
    setCarInfoByImei () {
      this.$axios.post('/v3/u/user/getAllVehicle',{}).then((response) =>{
        if (response.data.ret === 0) {
          let reqData = response.data.data;
          if(reqData.length){
            const findOtherDevice = (reqData||[]).shift();
            this.setDefaultImei(findOtherDevice.imei)
          }else{
            this.$cookies.set('imei', "");
            this.$router.replace('/');
          }
        }else{
          this.$dialog({
            message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备列表失败（' + response.data.ret + '）'
          })
        }
      })
  },
  setDefaultImei(imei){
    this.$axios.post('/v3/u/user/setFavoriteVehicle',{imei:imei}).then(res=>{
      if (res.data.ret === 0) {
          this.$cookies.set('imei', imei);
        }else{
          this.$dialog({
            message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '设置缺省设备失败（' + res.data.ret + '）'
          })
        }
    })
  },
  },
  created () {
    let ua = navigator.userAgent.toLowerCase();
    if (!this.$store.state.isDev && !(/micromessenger/i.test(ua))) {
        console.log('非微信环境');
        // this.$router.push('/error?type=wx');
      }
      const unsubscribe = this.$store.subscribe((mutation, state) => {
      if(mutation.type==='deviceBindChange' && mutation.payload){
        this.setCarInfoByImei()
        this.$store.commit('deviceBindChange',false)
      }
    })
    },
}
